export default {
    namespaced: true,
    state: {
        active: false,
        checked: false,
        text: '',
        message: '',
        messageLabel: '',
    },
    actions: {
        SET ({commit, state, dispatch, rootState}, data) {
            state.checked = data;
            return dispatch('AJAX_POST', {action: 'setGiftWrapping', data: { value: data ? '1' : '0' }}, { root: true })
                .then((result) => {
                    if (result.status === 'error') {
                        resolve(result);
                    } else {
                        return dispatch('SYNC_SUMMARY', null, { root: true });
                    }
                });
        },
    },
    mutations: {
        INIT (state, config) {
            state.active = config.active;
            state.text = config.text;
            state.checked = config.checked === '1';
            state.messageLabel = config.messageLabel;
        },
        SET (state, recyclable) {
            state.checked = recyclable;
        },
        SET_MESSAGE (state, message) {
            state.message = message;
        }
    }
}